import React from 'react';

// CORE COMPONENTS
import clsx from 'clsx';
import Sprite from 'core/tools/Sprite';
import Tooltip from 'core/tools/Tooltip';

// STYLES
import styles from './tableIcon.module.scss';

// MAIN COMPONENT
const TableIcon = ({
  as: Component = 'div',
  className,
  code
}) => (
  <Tooltip
    wrapperClassName={styles.tooltip}
    variant={code.variant}
    tip={code.label}
  >
    <Component className={clsx(styles.container, className)}>
      <Sprite
        className={code.className}
        use={code.icon}
      />
    </Component>
  </Tooltip>
)

// EXPORT
export default TableIcon;
